import PublicLayout from "@/components/public/PublicLayout";
import { Card } from "@/components/ui/card";

export function Privacy() {
  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-16 prose prose-slate dark:prose-invert prose-headings:font-heading">
        <h1>Privacy Policy</h1>
        <p className="text-sm text-muted-foreground">Effective date: 1 April 2026</p>
        <p>TheBillPro (&quot;we&quot;, &quot;us&quot;) respects your privacy. This policy explains what data we collect, how we use it, and the rights you have.</p>
        <h2>Information we collect</h2>
        <ul>
          <li><b>Account data:</b> name, mobile, email, password (hashed), business details you enter.</li>
          <li><b>Business data:</b> customers, invoices, quotations, inventory and other data you create using TheBillPro.</li>
          <li><b>Usage data:</b> anonymised metrics that help us improve the product.</li>
        </ul>
        <h2>How we use it</h2>
        <ul>
          <li>To provide and improve TheBillPro.</li>
          <li>To communicate service updates and billing notices.</li>
          <li>To secure your account and prevent fraud.</li>
        </ul>
        <h2>Data storage & security</h2>
        <p>Data is encrypted in transit and stored on secure cloud infrastructure. Passwords are hashed using bcrypt. Card details are never stored on our servers — Razorpay handles all payment data.</p>
        <h2>Your rights</h2>
        <p>You can access, edit or delete your account data any time. Cancelling your subscription does <b>not</b> auto-delete your business data.</p>
        <h2>Contact</h2>
        <p>Reach us at <a href="mailto:privacy@thebillpro.com">privacy@thebillpro.com</a>.</p>
      </section>
    </PublicLayout>
  );
}

export function Terms() {
  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-16 prose prose-slate dark:prose-invert prose-headings:font-heading">
        <h1>Terms &amp; Conditions</h1>
        <p className="text-sm text-muted-foreground">Effective date: 1 April 2026</p>
        <p>By using TheBillPro you agree to these terms.</p>
        <h2>Subscription</h2>
        <p>TheBillPro is offered on a subscription basis starting at ₹99/month. A 14-day free trial is provided. You can cancel any time; access continues until the end of the paid period.</p>
        <h2>Acceptable use</h2>
        <p>You agree not to use TheBillPro for illegal activity, spam, or to store or transmit malicious code. You are responsible for the accuracy of data you enter, including GST numbers and tax invoices you generate.</p>
        <h2>Payments</h2>
        <p>Payments are processed by Razorpay. We do not store card details. Failed payments may result in service suspension after a grace period.</p>
        <h2>Data ownership</h2>
        <p>You own all business data you create in TheBillPro. You can export it at any time. We never sell your data.</p>
        <h2>Limitation of liability</h2>
        <p>TheBillPro is provided &quot;as is&quot;. Users are responsible for verifying GST calculations and legal compliance with their local jurisdiction.</p>
        <h2>Changes</h2>
        <p>We may update these terms; material changes will be communicated by email.</p>
        <h2>Contact</h2>
        <p>Questions: <a href="mailto:legal@thebillpro.com">legal@thebillpro.com</a></p>
      </section>
    </PublicLayout>
  );
}
